import { Device, DeviceStatus, DeviceType, StaleAlertSeverity } from "@core/models/domain/device.domain";
import { DeviceResponse } from "@core/models/response/device.response";

/**
 * Converts a `DeviceResponse` object into a `Device` domain object.
 *
 * This function maps the properties of the response object to the corresponding fields in the domain object.
 * It also converts the `activationDatetime`, `creationDatetime`, and `lastModifiedDatetime` fields into JavaScript `Date` objects.
 *
 * @param {DeviceResponse} response - The response object containing device information.
 * @returns {Device} A domain object representing the device.
 */
export function buildDeviceFromResponse(response: DeviceResponse): Device {
    return {
        id: response.id,
        accountId: response.accountId,
        serialNumber: response.serialNumber,
        token: response.token,
        type: response.type as DeviceType,
        model: response.model,
        status: response.status as DeviceStatus,
        disabledForSchool: response.disabledForSchool,
        activationDatetime: response.activationDatetime ? new Date(response.activationDatetime) : undefined,
        creationDatetime: new Date(response.creationDatetime),
        lastModifiedDatetime: new Date(response.lastModifiedDatetime),
        enrolmentDatetime: new Date(response.enrolmentDatetime),
        registrationRequestedDatetime: response.registrationRequestedDatetime ? new Date(response.registrationRequestedDatetime) : undefined,
        registrationRequestCount: response.registrationRequestCount,
        staleAlertSeverity: response.staleAlertSeverity as StaleAlertSeverity,
        staleSince: response.staleSince ? new Date(response.staleSince) : undefined
    };
}